export default __webpack_public_path__ + "static/media/default.af0de252.xml";